// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1OtHQ","info":"PatientInfo_info__MC76c"};